export default __webpack_public_path__ + "static/r170-large-1c886bca5c8f72ded3dfaf212f5f573f.png";